module.exports = __webpack_public_path__ + "static/media/Statua_033.221b6838.jpg";